<template>
    <div>
        <nav-breadcrumb :menu="[{label: '留言'}]"/>
        <div class="bg-purple of">
            <el-tabs v-model="BranchMessageStatus">
                <el-tab-pane label="我发起的" name="send" >
                    <div class="xzpadd10 of">
                        <data-table
                            :table-data="tableData"
                            :columns="columns"
                            :page.sync="page"
                            :pageSize.sync="pageSize"
                            :filters.sync="filters"
                            :actions="actions"
                        />
                    </div>
                </el-tab-pane>
                <el-tab-pane label="我收到的" name="recipient" >
                    <div class="xzpadd10 of">
                        <data-table
                            :table-data="tableData"
                            :columns="columns2"
                            :page.sync="page"
                            :pageSize.sync="pageSize"
                            :filters.sync="filters"
                            :actions="actions"
                        />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" title="指派分公司">
            <el-form :model="dataForm" :rules="dataRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24">
                        <el-form-item label="回复内容：" prop="m__replies" :rules="{required: true, message: '回复内容不能为空'}" style="width: 60%">
                            <el-input type="textarea" v-model="dataForm.m__replies" style="margin-bottom:10px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="tr xzmt">
                    <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
                    <el-button @click="dialogVisible=false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery,removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "BranchMessageList",
        data(){
            return{
                BranchMessageStatus:'send',
                dialogVisible:false,
                dataForm:{m__messageId:''},
                dataRules:{},
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '留言内容',
                        field: 'm__content'
                    },
                    {
                        label: '接收者',
                        field: 'm__recipientName',
                    },
                    {
                        label: '留言时间',
                        field: 'm__sendTime',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm')
                        }
                    },
                    {
                        label: '状态',
                        field: 'm__replyTime',
                        formatter: function (r,c,v) {
                            if(v)
                                return '已回复'
                            else
                                return '待回复'
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                messageId: row.m__messageId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '回复',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.dataForm.m__messageId = row.m__messageId
                                    this.dialogVisible = true

                                },
                                conditions: row=> {
                                    return row.m__replyTime == null && row.m__recipientId==this.$store.state.userInfo.u__userId

                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                },
                                conditions: row=> {
                                    return row.m__replyTime == null && row.m__senderId==this.$store.state.userInfo.u__userId

                                }
                            }
                        ]
                    }
                ],
                columns2:[
                    {
                        type: 'index'
                    },
                    {
                        label: '留言内容',
                        field: 'm__content'
                    },
                    {
                        label: '发起者',
                        field: 'm__senderName',
                    },
                    {
                        label: '留言时间',
                        field: 'm__sendTime',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm')
                        }
                    },
                   /* {
                        label: '状态',
                        field: 'm__replyTime',
                        formatter: function (r,c,v) {
                            if(v)
                                return '已回复'
                            else
                                return '待回复'
                        }
                    },*/
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                messageId: row.m__messageId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '回复',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.dataForm.m__messageId = row.m__messageId
                                    this.dialogVisible = true

                                },
                                conditions: row=> {
                                    return row.m__replyTime == null && row.m__recipientId==this.$store.state.userInfo.u__userId

                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                },
                                conditions: row=> {
                                    return row.m__replyTime == null && row.m__senderId==this.$store.state.userInfo.u__userId

                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        n__title: '',
                        m__recipientName: '',
                        m__senderName: '',
                        m__sendTime:[],
                    },
                    columns: [
                        {
                            label: '标题',
                            component: 'el-input',
                            field: 'n__title',
                            span: 8
                        },
                        {
                            label: '发布日期',
                            component: 'date-range-picker',
                            field: 'm__sendTime',
                            op: ['gteq', 'lteq'],
                            span: 16
                        },
                        /*{
                            label: '状态',
                            component: 'el-select',
                            field: 'n__title',
                            span: 8
                        },*/
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return this.BranchMessageStatus=='send'?{
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.search.m.senderId': this.$store.state.userInfo.u__userId,
                    'xlist.search.m.senderId.op' : 'eq',
                    'xlist.sort.dataField': 'm.sendTime',
                    'xlist.sort.order': 'desc'
                }:{
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.search.m.recipientId': this.$store.state.userInfo.u__userId,
                    'xlist.search.m.recipientId.op' : 'eq',
                    'xlist.sort.dataField': 'm.sendTime',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                if(this.BranchMessageStatus=='send'){
                    this.filters.columns[0].label="接收者"
                    this.filters.columns[0].field="m__recipientName"
                }else{
                    this.filters.columns[0].label="发起者"
                    this.filters.columns[0].field="m__senderName"
                }
                xhr.getBranchMessageList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        dataForm.m__checked = true
                        xhr.replyBranchMessage(dataForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.getData()
                                    this.dialogVisible = false
                                    this.dataForm={
                                        m__messageId:''
                                    }
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchMessage,
                    {
                        'm.messageId' : row.m__messageId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchMessageList.vue